import React from 'react'
import { themeGet } from '@styled-system/theme-get'
import styled from 'styled-components'
import { color, compose } from 'styled-system'
import { textStyle } from '@zuto/utilities'
import Box from '@zuto/core/src/box'
import { SecureDataIcon } from '@zuto/atoms/src/SecureData/SecureDataIcon'

export type PrivacyNoticeProps = {
  title: string
  hideSecureIcon?: boolean
  isInMSMExperiment?: boolean
}

const StyledSubheading = styled.a`${(props) => compose(color, textStyle(props))({
  ...props,
  ...themeGet('privacyNotice.subheading')(props)
})}
`
const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const PrivacyNotice = ({ title, hideSecureIcon = false, isInMSMExperiment = false }: PrivacyNoticeProps): JSX.Element => (
  <Wrapper mt={isInMSMExperiment ? [5, 5] : [8, 7]} mb={[5, 9]}>
    {hideSecureIcon ? <></> : <SecureDataIcon title={title} />}
    <StyledSubheading href="/privacy/" target="_blank">Privacy Policy</StyledSubheading>
  </Wrapper>
)

export default PrivacyNotice
